import { render, staticRenderFns } from "./product_package.vue?vue&type=template&id=5bc2650a&scoped=true&"
import script from "./product_package.vue?vue&type=script&lang=js&"
export * from "./product_package.vue?vue&type=script&lang=js&"
import style0 from "./product_package.vue?vue&type=style&index=0&id=5bc2650a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc2650a",
  null
  
)

export default component.exports